import createFormData from './createFormData'
import fetchJson from './fetchJson'

export async function createSubmission(data) {
  const submissionData = {
    body: data.body,
    reason: data.reason,
    image: data.image,
    metadata: data.metadata,
  }

  // Only add reportable data if both type and id are present
  if (data.reportable_type && data.reportable_id) {
    submissionData.reportable_type = data.reportable_type
    submissionData.reportable_id = data.reportable_id
  }

  const formData = createFormData({ submission: submissionData })

  return await fetchJson(`/api/submissions`, {
    method: 'POST',
    body: formData,
  })
}
